(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabPropertiesDetailController', TabPropertiesDetailController);

    TabPropertiesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabProperties'];

    function TabPropertiesDetailController($scope, $rootScope, $stateParams, entity, TabProperties) {
        var vm = this;
        vm.tabProperties = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabPropertiesUpdate', function(event, result) {
            vm.tabProperties = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
